import React, { useEffect, useState } from "react";
import "./index.css";

const Footer = () => {
  const [versionInfo, setVersionInfo] = useState({ version: "", date: "" });

  useEffect(() => {
    fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" })
      .then((res) => res.json())
      .then((data) => setVersionInfo(data))
      .catch((err) => console.error("Erro ao buscar versão:", err));
  }, []);

  return (
    <footer className="footer">
      <div className="footer-content">
        <p>
          © {new Date().getFullYear()} Wensystem. Todos os direitos reservados.{" "}
          (v.{versionInfo.version} {versionInfo.date})
          <br />
          Desenvolvido por{" "}
          <a href="https://wensystem.com.br" target="_blank" rel="noopener noreferrer">
            Wensystem
          </a>
          .
          <br />
          <img
            className="footer-logo"
            src="https://wensystem.com.br/wp-content/uploads/elementor/thumbs/wen-p623lz4kkweo04kemh8w9xxnnnil4y52p7qm1kzev8-q2udnzzadgwf28zy01to57p9qt3p3g9kjh2rvsjzzc.png"
            alt="Logo Wensystem"
          />
        </p>
      </div>
    </footer>
  );
};

export default Footer;